import { WebSocketService } from 'js/services/webSocket.service';

import { actionTypes } from './constants';
import * as Types from './types';
import { ILiveGamesTable, TLiveGamesTableUpdate, ILiveGamesSubscription } from '../types';

export const startLiveIntegration = (): Types.IUpdateIsNeedToStartAction => ({
    type: actionTypes.LIVE_GAMES_IS_NEED_TO_START_UPDATE,
    payload: true
});

export const updateIsNeedToStart = (isNeedToStart: boolean): Types.IUpdateIsNeedToStartAction => ({
    type: actionTypes.LIVE_GAMES_IS_NEED_TO_START_UPDATE,
    payload: isNeedToStart
});

export const resetTables = (): Types.IResetTablesAction => ({
    type: actionTypes.LIVE_GAMES_RESET
});

export const setSocket = (socket: WebSocketService): Types.ISetSocketAction => ({
    type: actionTypes.LIVE_GAMES_SOCKET_SET,
    payload: socket
});

export const updateConnectionStatus = (status: boolean): Types.IUpdateConnectionStatusAction => ({
    type: actionTypes.LIVE_GAMES_CONNECTION_STATUS_UPDATE,
    payload: status
});

export const updateReconnectionStatus = (status: boolean): Types.IUpdateReconnectionStatusAction => ({
    type: actionTypes.LIVE_GAMES_RECONNECTION_STATUS_UPDATE,
    payload: status
});

export const addSubscription = (
    { tables, subscriptionId, correlationId }: ILiveGamesSubscription
): Types.IAddSubscriptionAction => ({
    type: actionTypes.LIVE_GAMES_SUBSCRIPTION_ADD,
    payload: { tables, subscriptionId, correlationId }
});

export const removeSubscription = (subscriptionIds: string[]): Types.IRemoveSubscriptionAction => ({
    type: actionTypes.LIVE_GAMES_SUBSCRIPTION_REMOVE,
    payload: subscriptionIds
});

export const updateTables = (
    { tables, subscriptionId }: { tables: TLiveGamesTableUpdate[]; subscriptionId: string }
): Types.IUpdateTablesAction => ({
    type: actionTypes.LIVE_GAMES_TABLES_UPDATE,
    payload: { tables, subscriptionId }
});

export const addTables = (
    { tables, subscriptionId }: { tables: ILiveGamesTable[]; subscriptionId: string }
): Types.IAddTablesAction => ({
    type: actionTypes.LIVE_GAMES_TABLES_ADD,
    payload: { tables, subscriptionId }
});

export const removeTables = (
    { tables, subscriptionId }: { tables: string[]; subscriptionId: string }
): Types.IRemoveTablesAction => ({
    type: actionTypes.LIVE_GAMES_TABLES_REMOVE,
    payload: { tables, subscriptionId }
});

export const updateLiveGamesImagesTimestamp = (): Types.IUpdateLiveGamesImagesTimestampAction => ({
    type: actionTypes.LIVE_GAMES_IMAGES_TIMESTAMP_UPDATE,
    payload: Date.now(),
    isSilent: true
});

export const updateLiveGamesImagesIntervalId = (intervalId: number | null): Types.IUpdateLiveGamesImagesIntervalIdAction => ({
    type: actionTypes.LIVE_GAMES_IMAGES_INTERVAL_ID_UPDATE,
    payload: intervalId
});
